import React from 'react';
import cn from 'classnames';

import { OptionType, SelectField } from './form-fields';

type SortBySelectorProps = {
  className?: string;
  labelClassName?: string;
  options: OptionType[];
  value: string | number | null;
  onChange: (value: string | number | null) => void;
};

export const SortBySelector: React.FC<SortBySelectorProps> = ({
  options,
  value,
  onChange,
  className,
  labelClassName,
}) => {
  return (
    <SelectField
      label="Sort by:"
      name="sortBy"
      selectClassName={className}
      value={value}
      options={options}
      onChange={value => {
        if (typeof value === 'string' || typeof value === 'number') {
          onChange(value);
        }
      }}
      labelClassName={cn('flex whitespace-nowrap items-center min-w-[160px] md:gap-x-4', labelClassName)}
    />
  );
};
